import { SmoothScroll } from "../components/site/SmoothScroll";
import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { EditorialMarquee } from "../components/site/EditorialMarquee";
import { Manifesto } from "../components/site/Manifesto";
import { Products } from "../components/site/Products";
import { MultiPart } from "../components/site/MultiPart";
import { Sectors } from "../components/site/Sectors";
import { Gallery } from "../components/site/Gallery";
import { Capabilities } from "../components/site/Capabilities";
import { QuoteContact } from "../components/site/QuoteContact";
import { Footer } from "../components/site/Footer";

export default function Landing() {
  return (
    <SmoothScroll>
      <div className="grain relative bg-background text-foreground min-h-screen">
        <Header />
        <main>
          <Hero />
          <EditorialMarquee />
          <Manifesto />
          <Products />
          <MultiPart />
          <Sectors />
          <Gallery />
          <Capabilities />
          <QuoteContact />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}
